export const isExpiryAlertProduct = (product) => {
  if (product?.is_expiry_alert !== undefined && product?.is_expiry_alert !== null) {
    return Boolean(Number(product.is_expiry_alert) || product.is_expiry_alert === true);
  }

  if (!product?.has_expiry || !product?.expiry_alert_date) {
    return false;
  }

  const alertDate = new Date(product.expiry_alert_date);
  const today = new Date();
  alertDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return alertDate <= today;
};

export const sortProductsByExpiryAlert = (products) => {
  return [...products].sort((a, b) => {
    const aAlert = isExpiryAlertProduct(a);
    const bAlert = isExpiryAlertProduct(b);

    if (aAlert !== bAlert) {
      return aAlert ? -1 : 1;
    }

    if (aAlert && bAlert && a.expiry_date && b.expiry_date) {
      return new Date(a.expiry_date) - new Date(b.expiry_date);
    }

    return 0;
  });
};

export const getProductCardClassName = (product) => {
  return isExpiryAlertProduct(product)
    ? "product-card product-card-expiry-alert"
    : "product-card";
};
